package core.sentry

actual fun captureException(e: Throwable) {}